module.exports = {
    "breadcrumbs": `Miez de p\xe2ine`
};


//# sourceMappingURL=ro-RO.main.js.map
